

export class TipoDeclaracaoEnum {

    public static values = [
        { title: 'Empréstimo Pessoal', value: 2 },
        { title: 'Empréstimo Pessoal', value: 3 },
        { title: 'Empréstimo Extraordinário', value: 5 },
        { title: 'Empréstimo Especial', value: 7 },
        { title: 'Financiamento Imobiliário', value: 0 },
        { title: 'Financiamento Imobiliário', value: 1 },
        { title: 'Financiamento Imobiliário', value: 4 },
        { title: 'Financiamento Imobiliário', value: 6 },
        { title: 'Empréstimo PREVI', value: 8 },
        { title: 'Financiamento PREVI', value: 9 }
    ]

    public static alocarTitle(tipo) {
        return this.values.find(item => item.value === tipo).title;
    }


}








// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/enum/tipo-delcaracao.ts